export default {
  messages: {
    configUpdatedSuccess: '配置更新成功',
    saveSuccess: '保存成功',
    createSuccess: '创建成功',
    saveWorkflowFailed: '保存工作流失败',
    cloneSuccess: '复制成功',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    confirm: '确定',
    cancel: '取消',
    workflowStarted: '工作流已启动',
    uploadSuccess: '上传成功',
    uploadFlowExampleFailed: '上传工作流测试示例失败',
    updateFlowExampleFailed: '修改工作流测试示例失败',
    deleteFlowExampleFailed: '删除工作流测试示例失败',
    saveFlowExampleFailed: '保存工作流测试示例失败',
    workflowHistorySaveFailed: '保存工作流历史失败',
    workflowVersionNameUpdateSuccess: '更新记录名称成功',
    workflowVersionNameUpdateFailed: '更新记录名称失败',
    workflowVersionPublishSuccess: '工作流版本发布成功',
    workflowVersionPublishFailed: '发布工作流版本失败',
    workflowHistoryListFetchFailed: '获取工作流历史列表失败',
    workflowHistoryDetailFetchFailed: '获取工作流历史详情失败',
    workflowVersionDeprecated: '工作流版本已废弃',
    workflowVersionDeprecateFailed: '废弃工作流版本失败',
    workflowVersionDeleteConfirmTitle: '确认删除',
    workflowVersionDeleteConfirmContent: '确定要删除 "{name}" 吗？',
    loadWorkflowFailed: '加载工作流失败',
    loadWorkflowTagsFailed: '加载工作流标签失败',
    loadWorkflowListFailed: '加载工作流列表失败',
    getWorkflowDetailFailed: '获取工作流详情失败',
    collaborationDataReset: '协同数据已重置',
    collaborationResetFailed: '重处理失败',
    historySnapshotRestored: '历史版本已恢复',
    historySnapshotRestoreFailed: '恢复失败',

    // HTTP 错误
    httpUnauthorized: '未授权，请重新登录',
    httpForbidden: '拒绝访问',
    httpNotFound: '请求的资源不存在',
    httpServerError: '服务器内部错误',
    httpRequestFailed: '请求失败',
    httpTimeout: '请求超时，请稍后重试',

    // 功能
    featureNotSupportedInEdition: '当前版本不支持该功能',

    // 用户
    logoutSuccess: '登出成功',

    // WebSocket
    wsConnectFailed: 'WebSocket 连接失败，请检查服务是否启动',
    wsModuleLoadFailed: 'WebSocket 连接模块加载失败',
    wsNotConnected: 'WebSocket 未连接，请稍后重试',

    // 快速实验
    fastExperimentCompleted: '快速实验完成',
    experimentError: '实验错误: {error}',
    inputJsonFormatError: '输入参数格式错误，请检查 JSON 格式',
    fastExperimentStarted: '快速实验已开始，等待结果...',
    fastExperimentStartFailed: '启动快速实验失败: {error}',
    experimentStopped: '实验已停止',

    // 用户管理
    searchUserFailed: '搜索用户失败',
    createUserFailed: '创建用户失败',

    // Prompt 模板
    promptTemplateDeleteSuccess: 'Prompt模板删除成功',
    promptTemplateDeleteFailed: 'Prompt模板删除失败',
    loadTemplateContentFailed: '加载模板内容失败',
    loadTemplateVersionFailed: '加载模板版本失败',
    pleaseSelectTemplate: '请选择一个模板',
    selectTemplateFailed: '选择模板失败',

    // JSON 导入
    invalidJsonData: '请输入有效的 JSON 数据',
    noImportableFields: 'JSON 数据中没有可导入的字段',
    fieldsImportedSuccess: '成功导入 {count} 个字段',
    importFailedCheckJson: '导入失败，请检查 JSON 格式',

    // 示例
    exampleMustBeValidJson: '示例内容必须是有效的JSON格式',

    // 节点配置
    pleaseSelectOrInputTemplateName: '请先选择或输入模板名称',

    // 节点模板
    applyNodeTemplateFailed: '应用节点模板失败: {error}',

    // 登录/Token
    confirmLogout: '确认退出',
    loginExpired: '您的登录信息已过期，请重新登录',
    reLogin: '重新登录',
    refreshTokenFailed: '刷新 token 失败',
  },
};
